import Cookie from "js-cookie";
import Intro from "./main/_intro.es6";
import Bg from "./main/_bg.es6";
import Mv from "./main/mv/_index.es6";

window.MAIN = {};
MAIN.cookie = Cookie;
MAIN.isVisit = MAIN.cookie.get("phrase_visit") ? true : false;
MAIN.isNarrow = window.matchMedia("(max-width: 767px)").matches;
const mediaQueryList = window.matchMedia("(max-width: 767px)");

window.scrollTo({
    top: 0,
    behavior: "smooth",
});

// ブラウザバック時は強制的にリロード
window.addEventListener("pageshow", (e) => {
    e.persisted && location.reload();
});

window.addEventListener("DOMContentLoaded", () => {
    MAIN.intro = new Intro();
    MAIN.bg = new Bg();
    MAIN.mv = new Mv();
    manabi.replaceEnv();

    // const $reset = document.getElementById('reset');

    // $reset.addEventListener('click', () => {
    //     MAIN.cookie.remove('phrase_visit');
    //     location.reload();
    // });
});
